import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

import { Connection } from '@/views/Auth';
import { Dashboard, Stats, UserList, UserEdit } from '@/views/Dashboard';

Vue.use(VueRouter);

const routes = [
  {
    path: '',
    name: 'Landing',
  },
  {
    path: '/connexion',
    name: 'Connection',
    component: Connection,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    children: [
      {
        path: 'stats',
        name: 'Stats',
        component: Stats,
      },
      {
        path: 'utilisateurs',
        name: 'UsersList',
        component: UserList,
      },
      {
        path: 'utilisateurs/:id',
        name: 'UserEdit',
        component: UserEdit,
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (!store.getters['user/isLogged']) {
    await store.dispatch('user/login', store.getters['auth/getToken']);
  }

  if (to.name !== 'Connection' && !store.getters['user/isLogged']) {
    return next({ name: 'Connection' });
  }

  if (to.name === 'Landing' && store.getters['user/isLogged']) {
    return next({ name: 'Dashboard' });
  }

  return next();
});

export default router;
